/* gets initial data on login and refresh on new company for admins */

export const onLogin = ({email, store}) => {
  return store.dispatch("user/bind", email).then(() => {
    if(typeof store.getters["user/get"] === 'undefined')
      return false
      
    var promisses = []
    
    promisses.push(store.dispatch("companies/bind", store.getters["user/get"].worksatcompany[0]))
    promisses.push(store.dispatch("containers/bind"))
    
    return Promise.all(promisses)
  })
}
